export const topCustomerData = [
    {
        img:"01",
        name:"Cameron Broadbet",
        id:"#736438",
        status:"Gold",
        color:"secondary",
        className:"pt-0"
    },
    {
        img:"02",
        name:"Margaret Adelman",
        id:"#856932",
        status:"Gold",
        color:"secondary"
    },
    {
        img:"03",
        name:"Ronald Barrlumsed",
        id:"#365248",
        status:"Platinum",
        color:"primary"
    },
    {
        img:"04",
        name:"Melvins Novakerofa",
        id:"#125896",
        status:"Platinum",
        color:"primary"
    },
    {
        img:"05",
        name:"Jeffeld Connorsebarr",
        id:"#759684",
        status:"Silver",
        color:"warning",
        className:"pb-0"
    }
]